"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var decimalFormatter = function decimalFormatterHelper(stringWithDecimal) {
  var emptyDecimals = new RegExp(/\.00/);
  var removeDecimal = emptyDecimals.test(stringWithDecimal);
  return removeDecimal ? stringWithDecimal.replace(emptyDecimals, '') : stringWithDecimal;
};

var _default = decimalFormatter;
exports["default"] = _default;